const key = "elements"

export function selectElements(state) {
  return state[key]
}

export function selectElementsAddress(state) {
  return selectElements(state).address
}

export function selectElementsNewAddress(state) {
  return selectElements(state).newAddress
}

export function selectElementsLiquidClient(state) {
  return selectElements(state).liquid
}

export function selectElementsCartId(state) {
  return selectElements(state).cartId
}
